import { render } from "./PatientPrescription.vue?vue&type=template&id=53999b33&scoped=true"
import script from "./PatientPrescription.vue?vue&type=script&lang=js"
export * from "./PatientPrescription.vue?vue&type=script&lang=js"

import "./PatientPrescription.vue?vue&type=style&index=0&id=53999b33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53999b33"]])

export default __exports__